import { render, staticRenderFns } from "./editprofile_modal.vue?vue&type=template&id=3cda8262&scoped=true&"
import script from "./editprofile_modal.vue?vue&type=script&lang=js&"
export * from "./editprofile_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cda8262",
  null
  
)

export default component.exports